export const SAVE_TERM = 'SAVE_TERM';
export const SAVE_TABLE_ROW = 'SAVE_TABLE_ROW';